<template>
  <bd-date-picker
    v-bind="$attrs"
    size="large"
    v-model="dateRange"
    type="daterange"
    range-separator="至"
    start-placeholder="开始日期"
    end-placeholder="结束日期"
    @change="_onChangeRange"
    style="width: 100%"
  >
    <template v-slot:prefix>
      <span>{{ prefixText }}</span></template
    >
  </bd-date-picker>
</template>

<script>
import { startOfDay, endOfDay } from 'date-fns'
export default {
  emits: ['update:begin', 'update:end', 'on-change'],
  name: 'ElRangeDatePicker',
  props: {
    begin: {
      type: [String, Number, Date],
      default() {
        return ''
      }
    },
    prefixText: String,
    end: {
      type: [String, Number, Date],
      default() {
        return ''
      }
    },
    fixTimestamp: {
      type: Boolean,
      default() {
        return true
      }
    }
  },
  watch: {
    begin: {
      deep: true,
      handler(nv, ov) {
        this._setDesDaterange()
      }
    },
    end: {
      deep: true,
      handler(nv, ov) {
        this._setDesDaterange()
      }
    }
  },
  data() {
    return {
      dateRange: []
    }
  },
  created() {
    this._setDesDaterange()
  },
  methods: {
    _setDesDaterange() {
      if (this.begin || this.end) {
        const begin = new Date(this.begin)
        const end = new Date(this.end)
        this.dateRange = [begin, end]
      } else {
        this.dateRange = ['', '']
      }
    },
    _formatRange(ranges) {
      if (!ranges) return ['', '']
      let start = ranges[0]
      let end = ranges[1]
      // 用于修正结束时间，修正成结束日的23:59:59
      if (this.fixTimestamp) {
        start = start ? startOfDay(start).getTime() : ''
        end = end ? endOfDay(end).getTime() : ''
      }
      return [start, end]
    },
    _onChangeRange(daterange, type) {
      const ranges = this._formatRange(daterange, type)
      this.$emit('update:begin', ranges[0])
      this.$emit('update:end', ranges[1])
      this.$emit('on-change', ranges[0] || '', ranges[1] || '')
    }
  }
}
</script>
